// 사이트 콘텐츠 기본값. DB(/api/content.php) 응답이 없을 때 쓰이고, DB 초기 입력(seed)에도 사용된다.
// 키 이름 = DB content.ckey. 상대경로 + .ts 확장자 import는 서버 Node 시드 스크립트에서도 읽기 위함.
import * as home from "../mocks/home.ts";
import * as about from "../mocks/about.ts";
import * as admission from "../mocks/admission.ts";
import * as classes from "../mocks/classes.ts";
import * as schedule from "../mocks/schedule.ts";

export interface PageHeroContent {
  tag: string;
  titleLine1: string;
  titleLine2: string;
  description: string;
  image: string;
}

const pageHero = (tag: string, titleLine1: string, titleLine2: string, description: string, image: string): PageHeroContent => ({
  tag,
  titleLine1,
  titleLine2,
  description,
  image,
});

export const defaults = {
  "site.settings": {
    phone: "02-002-2525",
    hours: "평일 13:00 – 22:00 · 토 10:00 – 18:00",
    address: "서울특별시 서초구 반포대로 123, 4층",
    footerDesc:
      "이름값 하는 수학, 성적으로 증명합니다. 초·중·고 전 학년 수학 전문, 소수정예 밀착 관리로 학생 한 명 한 명의 성장을 책임집니다.",
  },

  "home.hero": {
    badge: "초·중·고 수학 전문 · 소수정예 1:6",
    titleLine1: "이름값 하는 수학,",
    titleHighlight: "성적으로",
    titleRest: "증명합니다",
    description:
      "18년간 수학만 가르쳐 온 전문성으로, 학생 한 명 한 명의 실력을 끝까지 책임집니다. 입학테스트로 현재를 진단하고, 가장 맞는 길을 안내해 드립니다.",
    backgroundImage: "/uploads/site/mbhj-hero-main-01.jpg",
    directorImage: "/uploads/site/4c2d43ee-4b9c-44d5-8253-2210fe32747b.png",
    directorName: "김명헌 원장",
    directorCaption: "수학 교육 18년 · 서울대 수학교육과",
  },
  "home.heroStats": home.heroStats,
  "home.marqueeItems": home.marqueeItems,
  "home.features": home.features,
  "home.levels": home.levels,
  "home.results": home.results,
  "home.testimonials": home.testimonials,

  "pages.hero": {
    admission: pageHero(
      "ADMISSION",
      "이름값 하는 수학의",
      "입학을 안내합니다",
      "상담부터 입학테스트, 반 배정까지. 학생의 현재 실력을 정확히 진단해 가장 적합한 반을 설계해 드립니다.",
      "/uploads/site/mbhj-admission-hero-01.jpg",
    ),
    classes: pageHero(
      "CLASSES",
      "학년별로 다른",
      "맞춤 커리큘럼",
      "초등부·중등부·고등부, 학년과 목표에 따라 가장 효과적인 수업을 설계합니다. 한 반 최대 6명의 소수정예로 밀착 관리합니다.",
      "/uploads/site/mbhj-classes-hero-01.jpg",
    ),
    schedule: pageHero(
      "SCHEDULE",
      "학기중 · 방학중",
      "시간표 안내",
      "정규 학기와 방학 특강의 시간표를 안내합니다. 시간표는 학기마다 조정될 수 있으니, 상담을 통해 현재 개설된 반을 확인해 주세요.",
      "/uploads/site/mbhj-schedule-hero-01.jpg",
    ),
    about: pageHero(
      "ABOUT",
      "수학 한 길,",
      "18년의 전문성",
      "화려한 말 대신 성적으로 증명해 온 명불허전 수학학원의 이야기와 강사진을 소개합니다.",
      "/uploads/site/mbhj-about-hero-01.jpg",
    ),
    consult: pageHero(
      "CONSULTATION",
      "지금의 실력을 진단하면",
      "다음 성적이 보입니다",
      "상담 신청을 남겨주시면 담당 선생님이 학습 진단과 함께 가장 적합한 반을 안내해 드립니다. 상담은 무료입니다.",
      "/uploads/site/mbhj-consult-hero-01.jpg",
    ),
  },

  "admission.admissionSteps": admission.admissionSteps,
  "admission.testSubjects": admission.testSubjects,
  "admission.testPoints": admission.testPoints,
  "admission.testImage": admission.testImage,

  "classes.classLevels": classes.classLevels,

  "schedule.termSchedule": schedule.termSchedule,
  "schedule.vacationSchedule": schedule.vacationSchedule,

  "about.director": about.director,
  "about.teachers": about.teachers,
};

export type SiteContent = typeof defaults;
export type ContentKey = keyof SiteContent;
